export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-dislike-9db0af14e271a944b6aeb212eda07a2a.svg";